import { useEffect, useState } from "react"
import { AppContext } from "./app_context"
import { createTheme, ThemeProvider } from "@mui/material"
import { ptBR } from "@mui/material/locale"
import { Theme } from "../../../types/global/themeTypes"

import NoticeSnackbar from "../../../components/global/NoticeSnackbar"


function AppProvider({ children }: { children: JSX.Element }) {
  const [theme, setTheme] = useState<Theme>("light")
  const [navbarIsCollapsed, setNavbarIsCollapsed] = useState(window.matchMedia(`(min-width: 768px)`).matches ? false : true)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(window.matchMedia(`(min-width: 768px)`).matches ? true : false)
  const [noticeOpen, setNoticeOpen] = useState(false)
  const [messageNotice, setMessageNotice] = useState("")

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as Theme | null
    if (savedTheme) {
      setTheme(savedTheme)
      document.documentElement.classList.add(savedTheme)
    } else {
      document.documentElement.classList.add('light')
    }
  }, [])

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light'
    setTheme(newTheme)
    localStorage.setItem('theme', newTheme)

    document.documentElement.classList.remove(theme)
    document.documentElement.classList.add(newTheme)
  }

  const muiTheme = createTheme({
    palette: {
      mode: theme
    },
  }, ptBR)

  return (
    <AppContext.Provider value={{ theme, navbarIsCollapsed, isMobileMenuOpen, toggleTheme, setNavbarIsCollapsed, setIsMobileMenuOpen, setNoticeOpen, setMessageNotice }}>
      <ThemeProvider theme={muiTheme}>
        <NoticeSnackbar open={noticeOpen} onClose={() => setNoticeOpen(false)} message={messageNotice} />
        {children}
      </ThemeProvider>
    </AppContext.Provider>
  )
}

export default AppProvider